import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowRight, FiPlay } = FiIcons;

const Hero = () => {
  return (
    <section className="relative bg-gradient-to-br from-cyan-400 via-blue-500 to-blue-600 text-white overflow-hidden">
      <div className="absolute inset-0 bg-black/10"></div>
      <div className="relative container mx-auto px-6 py-16 md:py-24">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl mx-auto text-center"
        >
          <h1 className="text-4xl md:text-6xl font-bold leading-tight mb-6">
            Sana tu Mente,<br />
            <span className="text-yellow-300">Transforma tu Cuerpo</span> con<br />
            <span className="bg-gradient-to-r from-yellow-300 to-orange-300 bg-clip-text text-transparent">
              ESTRATEGIA M.E.T.A.
            </span>
          </h1>
          
          <p className="text-xl md:text-2xl mb-4 text-blue-100">
            Programa integral de 21 días con EMDR, Terapia Cognitiva y Alimentación Consciente.
          </p>
          
          <p className="text-lg mb-8 text-blue-50 max-w-3xl mx-auto">
            Un enfoque único para sanar tu mente, dejar atrás los bloqueos y transformar tu bienestar.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-yellow-400 text-blue-900 px-8 py-4 rounded-full font-bold text-lg hover:bg-yellow-300 transition-colors flex items-center gap-2 shadow-lg"
            >
              ¡Empieza ahora! Asegura tu cupo
              <SafeIcon icon={FiArrowRight} className="text-xl" />
            </motion.button>
            
            <motion.a
              whileHover={{ scale: 1.05 }}
              href="#"
              className="text-white underline hover:text-yellow-300 transition-colors flex items-center gap-2"
            >
              <SafeIcon icon={FiPlay} className="text-lg" />
              ¿Prefieres ver una clase gratuita?
            </motion.a>
          </div>
        </motion.div>
      </div>
      
      <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-white/20 to-transparent"></div>
    </section>
  );
};

export default Hero;